import { tap } from "rxjs/operators";
import { of } from "rxjs";

import { AppDataStateModel } from "@app/shared/models/app-data.model";
import { FailTask, FinishTask, RegisterTask, ResumeTask } from "@shared/actions/general.action";
// import { ActionTask, LongRunningTaskData, TaskScope, TaskDataRefreshStrategy } from "@shared/classes/task-manager";
import { TaskDataRefreshStrategy, TaskScope, TaskStatusEnum } from "@shared/enums";
import { ActionTask, LongRunningTaskData } from "@shared/classes/general";
import { Constants } from "@shared/constants";

export function LongRunningTask(target: Object, propertyKey: string, descriptor: PropertyDescriptor) {
  const originalMethod = descriptor.value;

  descriptor.value = async function (...args: any[]) {
    let taskId = args[1].taskId, longRunningCallback = false, dataUrl = "";
    const appState = <AppDataStateModel>(this as any).store.selectSnapshot((state: any) => state.appDataState);

    //For 'Application' scope task, we will not dispatch them for a second time unless they have been failed last time OR still in 'timeout' status to wait for resume.
    if (args[1].taskScope === TaskScope.APPLICATION && appState.taskManager.some(t => t.taskName === args[1].actionName && t.status != TaskStatusEnum.FAILED.toString() && t.status != TaskStatusEnum.TIMEOUT.toString())) {
      return of();
    }

    const task = appState.taskManager.find(t => t.taskId === taskId);
    if (!task) {
      args[0].dispatch(new RegisterTask({
        taskId: taskId,
        taskName: args[1].actionName,
        status: TaskStatusEnum.EXECUTING,
        taskData: args[1]
      } as ActionTask));
    } else {
      longRunningCallback = task.backgroundFinished;
      dataUrl = task.dataUrl;

      if (task.status != TaskStatusEnum.TIMEOUT || !task.backgroundFinished || !task.dataUrl) {
        return of();
      }

      args[0].dispatch(new ResumeTask(taskId));
    }

    const result = originalMethod.apply(this, [...args, { taskId: taskId, longRunningCallback: longRunningCallback, dataUrl: dataUrl } as LongRunningTaskData]);
    return result.pipe(tap((response: any) => {
      if (response && Constants.HttpResponseErrorCode.includes(response.httpResponseStatus)) {
        args[0].dispatch(new FailTask(taskId, response));
        return;
      }

      var data = args[1].refreshStrategy === TaskDataRefreshStrategy.OPT_OUT ? null : response;
      if (args[1].callback) {
        //If there is anything returned from inside the callback
        //We pass it to FinishTask action to set the Tasks's response data
        const transformedData = args[1].callback(args[0], response);
        data = (transformedData ? transformedData : response);
      }

      args[0].dispatch(new FinishTask(taskId, response));
    }));
  };

  return descriptor;
};
